import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { useDetalleMutuo } from "../../../context/mutuoContext";
import { Card, CardContent, Grid2 } from "@mui/material";
import Breadcrumb from "../../../components/ui/materialui/breadcrumb";
import { StateViewInterface } from "../interfaces/stateViews.interface";
import CustomAccordion from "../../../components/ui/materialui/customAccordion";
import TableSolicitudesLiquidadas from "../components/tableSolicitudesLiquidadas";
import TableSolicitudesGeneradas from "../components/tableSolicitudesGeneradas";
import { RespuestaSolicitudesPrepagoDto } from "../models";
import { IsDesactivado } from "../../detalleMutuo/services/servicesMutuo";
import { StatusCode } from "../../../utils/enums";

interface Props {
    setViewToShow: (nameView: keyof StateViewInterface) => void;
    setSolicitud: (solicitud: RespuestaSolicitudesPrepagoDto | null) => void;
    setIdSolicitud: (idSolicitud: number) => void;
    acordeonExpandido: string | null;
    setAcordeonExpandido: (acordeon: string | null) => void;
}

const ListadoSolicitudes: React.FC<Props> = ({ setViewToShow, setIdSolicitud, setSolicitud, acordeonExpandido, setAcordeonExpandido }: Props) => {

    const location = useLocation();
    const { id: idEmergente } = location.state || {}
    const { nombre, filtros, tipoMutuo, numeroOperacion } = useDetalleMutuo();
    const [idMutuo, setIdMutuo] = useState<number>(idEmergente);
    const [isDesactivado, setIsDesactivado] = useState(false);

    const EsDesactivado = async (idEmergente: number) => {
        const resp = await IsDesactivado(idEmergente);
        if (resp.status === StatusCode.Ok) {
            setIsDesactivado(resp.data.valor);
        }
    }

    useEffect(() => {
        EsDesactivado(idEmergente);
    }, [idEmergente])

    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'Cartera mutuos', state: filtros, url: '/cartera-mutuos' },
        { label: 'Prepagos', active: true },
        { label: `${numeroOperacion ?? ''} - ${tipoMutuo ?? ""} - ${nombre ?? ''}`, active: true },
    ];

    return (
        <>
            <Grid2 size={{ xs: 12, lg: 8 }}> <Breadcrumb items={breadcrumbItems} /> </Grid2>

            <Card sx={{ mb: 2, backgroundcolor: 'white' }} raised>
                <CardContent>
                    <CustomAccordion
                        title="Solicitudes generadas"
                        expandedDefault
                        expanded={acordeonExpandido === 'solicitudesGeneradas'}
                        onExpandedChange={(expanded) => {
                            if (expanded) {
                                setAcordeonExpandido('solicitudesGeneradas');
                            } else if (acordeonExpandido === 'solicitudesGeneradas') {
                                setAcordeonExpandido(null);
                            }
                        }}
                    >
                        <TableSolicitudesGeneradas
                            idMutuo={idEmergente}
                            setViewToShow={setViewToShow}
                            setIdSolicitud={setIdSolicitud}
                            isDesactivado={isDesactivado}
                        />
                    </CustomAccordion>

                    <CustomAccordion
                        title='Solicitudes liquidadas y recaudadas'
                        expandedDefault={false}
                        expanded={acordeonExpandido === 'solicitudesLiquidadas'}
                        onExpandedChange={(expanded) => {
                            if (expanded) {
                                setAcordeonExpandido('solicitudesLiquidadas');
                            } else if (acordeonExpandido === 'solicitudesLiquidadas') {
                                setAcordeonExpandido(null);
                            }
                        }}
                    >
                        <TableSolicitudesLiquidadas
                            idMutuo={idEmergente}
                            setSolicitud={setSolicitud}
                            setIdSolicitud={setIdSolicitud}
                            setViewToShow={setViewToShow}
                            isDesactivado={isDesactivado}
                        />
                    </CustomAccordion>
                </CardContent>
            </Card>
        </>
    )
}

export default ListadoSolicitudes;